import { optionalAuthApiClient } from '@/shared/lib/api-client';
import type { CatalogResponse, ClubPageResponse, PaywallOffer, ClubStatus } from '@bookclub/shared';

type ClubReferenceLike = {
  id?: string | null;
  clubId?: string | null;
  paywallSlug?: string | null;
};

export function resolveClubReference(club: ClubReferenceLike): string | null {
  return club.paywallSlug ?? club.id ?? club.clubId ?? null;
}

export function buildClubHref(
  club: ClubReferenceLike,
  source?: 'catalog' | 'my-clubs',
): string {
  const reference = resolveClubReference(club);
  if (!reference) {
    return '/catalog';
  }

  return `/clubs/${reference}${source ? `?source=${source}` : ''}`;
}

export async function fetchCatalog(
  q?: string,
  cursor?: string,
  status?: ClubStatus,
): Promise<CatalogResponse> {
  const searchParams: Record<string, string> = { limit: '20' };
  if (q) searchParams['q'] = q;
  if (cursor) searchParams['cursor'] = cursor;
  if (status) searchParams['status'] = status;
  return optionalAuthApiClient.get('clubs', { searchParams }).json<CatalogResponse>();
}

export async function fetchClubPage(clubReference: string): Promise<ClubPageResponse> {
  return optionalAuthApiClient.get(`clubs/${clubReference}/page`).json<ClubPageResponse>();
}

export async function fetchPaywallOffer(clubReference: string): Promise<PaywallOffer> {
  return optionalAuthApiClient.get(`clubs/${clubReference}/paywall`).json<PaywallOffer>();
}
